/**
 * ACWR heatmap colors aligned with AcwrModal / athlete ACWR chart (<0.8 under, 0.8–1.3 sweet, >1.3 overload).
 * @param {number|null|undefined} acwr
 * @returns {string} CSS color (hex)
 */
export function acwrToHeatmapColor(acwr) {
  if (acwr == null || Number.isNaN(acwr)) return 'hsl(var(--border))';
  if (acwr < 0.8) return '#3b82f6';
  if (acwr > 1.3) return '#ef4444';
  return '#22c55e';
}
